module.exports = "<div class=\"setupAction\">\n\t<!-- header -->\n<app-mail [action]=\"mailAction\"></app-mail>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/new-rule/setup-action/setup-action.component.html
// module id = 1440
// module chunks = 1